module.exports = __webpack_public_path__ + "static/media/Conkeldurr_gaussian2.47710302.png";